import { Chart } from 'react-google-charts';
import React, { useEffect, useState, useRef } from 'react';
import { SystemHealthApi } from '../../store/app/apis/index';
import ZoomOutMap from '@mui/icons-material/ZoomOutMap';

import { useParams } from 'react-router-dom';
import styles from './charts.module.css';
import Dialogbox from './dialog';
import { connect } from 'react-redux';
import { setHealth } from '../../store/app';

const options = {
  isStacked: true,
  legend: { position: 'none' },
  vAxis: {
    minValue: 0,
    maxValue: 100,
  },
  chartArea: { left: 40, top: 20, bottom: 40, right: 10, width: '100%', height: '150%' },
};

const GRAPH_TITLES = {
  cpu: 'CPU(%)',
  memory: 'Memory(%)',
  disk: 'Disk(%)',
  diskread: 'Disk Read(MB/s)',
  diskwrite: 'Disk Write(MB/s)',
  networktx: 'Network Bandwidth Out(KB/s)',
  networkrx: 'Network Bandwidth In(KB/s)',
};

export function Charts({ health, setHealth, ...props }) {
  const [dialog, setDialog] = useState(null);
  const [stats, setStats] = useState({
    file: [],
    disk: [],
    cpu: [],
    memory: [],
    diskread: [],
    diskwrite: [],
    networkrx: [],
    networktx: [],
  });
  const params = useParams();
  const totalData = useRef({ cpu: 0, memory: 0, disk: 0, uptime: 0 });
  useEffect(() => {
    getdata();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    healthdata();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [health]);
  const getdata = async () => {
    let response = await SystemHealthApi(
      {
        service: params.id,
        size: 500,
      },
      props.token,
    );
    if (!response) return;
    setHealth(response);
  };

  const healthdata = async () => {
    //get graph data
    var diskArr = [];
    var cpuArr = [];
    var memoryArr = [];
    var diskReadArr = [];
    var diskWriteArr = [];
    var networkRxArr = [];
    var networkTxArr = [];

    for (let index = health?.length - 1; index >= 0; index--) {
      const element = health[index];
      if (element?.meta === null) continue;
      let currentTimestamp = element?.ct;
      const date = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit' }).format(currentTimestamp);
      //get disk data
      let used = parseInt(element?.meta?.disk?.used);
      let free = parseInt(element?.meta?.disk?.free);
      let disk = (used + free) / (1024 * 1024);
      let totaldisk = Math.round((disk + Number.EPSILON) * 100) / 100;
      //get memory data

      let total = parseInt(element?.meta?.memory?.total);
      let used1 = parseInt(element?.meta?.memory?.used);
      let totalmemory = Math.round((total + Number.EPSILON) * 100) / 100;
      //get cpu data
      totalData.current = {
        ...totalData.current,
        cpu: element?.meta?.core,
        memory: totalmemory,
        uptime: element?.meta?.load?.uptime,
        disk: totaldisk,
      };
      cpuArr.push([date, element?.meta?.cpu?.wa, element?.meta?.cpu?.sy, element?.meta?.cpu?.us]);

      memoryArr.push([date, (used1 / total) * 100]);

      diskArr.push([date, (used / (used + free)) * 100]);
      //get diskstats data
      let reads = parseFloat(element?.meta?.diskrw?.reads) / (1024 * 1024);
      let writes = parseFloat(element?.meta?.diskrw?.writes) / (1024 * 1024);
      diskReadArr.push([date, reads]);
      diskWriteArr.push([date, writes]);
      //get network data
      let rxbytes = parseFloat(element?.meta?.network?.rxbytes) / (1024 * 1024 * 1024);
      let txbytes = parseFloat(element?.meta?.network?.txbytes) / (1024 * 1024 * 1024);
      networkRxArr.push([date, rxbytes]);
      networkTxArr.push([date, txbytes]);
    }
    setStats((state) => {
      return {
        ...state,
        disk: [['Time', 'used'], ...diskArr],
        cpu: [['Time', 'wa', 'sy', 'us'], ...cpuArr],
        memory: [['Time', 'used'], ...memoryArr],
        diskread: [['Time', 'read'], ...diskReadArr],
        diskwrite: [['Time', 'write'], ...diskWriteArr],
        networkrx: [['Time', 'rx'], ...networkRxArr],
        networktx: [['Time', 'tx'], ...networkTxArr],
      };
    });
  };
  const handleClick = (_event, val) => {
    setDialog({ data: stats[val], title: GRAPH_TITLES[val] });
  };
  const onDialogeClose = (event) => {
    setDialog(null);
  };

  return (
    <>
      <div className={styles.systemuptimediv}>
        <span className={styles.systemuptimespan}>System Uptime : {totalData?.current?.uptime}</span>
      </div>
      {dialog && <div>{<Dialogbox dialog={dialog} options={options} onClose={onDialogeClose} />}</div>}
      <div className={styles.chartGrid}>
        <div className={styles.cpu}>
          <div className={styles.chartdiv}>
            <div className={styles.chartflexheading}>
              <p>CPU(%)</p>
              <p>Cores:{totalData?.current?.cpu}</p>
              <ZoomOutMap onClick={(event) => handleClick(event, 'cpu')}></ZoomOutMap>
            </div>
            {health?.length !== 0 && <Chart chartType="AreaChart" data={stats?.cpu} options={options} />}
          </div>
        </div>
        <div className={styles.cpu}>
          <div className={styles.chartdiv}>
            <div className={styles.chartflexheading}>
              <p>Memory(%)</p>
              <p>Total Memory:{totalData?.current?.memory} MB</p>
              <ZoomOutMap onClick={(event) => handleClick(event, 'memory')}></ZoomOutMap>
            </div>
            {health?.length !== 0 && <Chart chartType="AreaChart" data={stats?.memory} options={options} />}
          </div>
        </div>
        <div className={styles.cpu}>
          <div className={styles.chartdiv}>
            <div className={styles.chartflexheading}>
              <p>Disk(%)</p>
              <p>Total Space:{totalData?.current?.disk} GB</p>
              <ZoomOutMap onClick={(event) => handleClick(event, 'disk')}></ZoomOutMap>
            </div>
            {health?.length !== 0 && <Chart chartType="AreaChart" data={stats?.disk} options={options} />}
          </div>
        </div>
        <div className={styles.cpu}>
          <div className={styles.chartdiv}>
            <div className={styles.chartflexheading}>
              <p>Disk Write(MB/s)</p>
              <ZoomOutMap onClick={(event) => handleClick(event, 'diskwrite')}></ZoomOutMap>
            </div>
            {health?.length !== 0 && <Chart chartType="AreaChart" data={stats?.diskwrite} options={options} />}
          </div>
        </div>
        <div className={styles.cpu}>
          <div className={styles.chartdiv}>
            <div className={styles.chartflexheading}>
              <p>Disk Read(MB/s)</p>
              <ZoomOutMap onClick={(event) => handleClick(event, 'diskread')}></ZoomOutMap>
            </div>
            {health?.length !== 0 && <Chart chartType="AreaChart" data={stats?.diskread} options={options} />}
          </div>
        </div>
        <div className={styles.cpu}>
          <div className={styles.chartdiv}>
            <div className={styles.chartflexheading}>
              <p>Network Bandwidth Out(KB/s)</p>
              <ZoomOutMap onClick={(event) => handleClick(event, 'networktx')}></ZoomOutMap>
            </div>
            {health?.length !== 0 && <Chart chartType="AreaChart" data={stats?.networktx} options={options} />}
          </div>
        </div>
        <div className={styles.cpu}>
          <div className={styles.chartdiv}>
            <div className={styles.chartflexheading}>
              <p>Network Bandwidth In(KB/s)</p>
              <ZoomOutMap onClick={(event) => handleClick(event, 'networkrx')}></ZoomOutMap>
            </div>
            {health?.length !== 0 && <Chart chartType="AreaChart" data={stats?.networkrx} options={options} />}
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    token: state.app.user.token,
    health: state.app.health,
  };
};
const mapDispatchToProps = {
  setHealth,
};

export default connect(mapStateToProps, mapDispatchToProps)(Charts);
